import axios from "axios";
import { ENV } from "../../config/environment";
import { API_V1_URL } from "./endpoints";
import { endSession, isSessionExpired } from "../auth/session";

const readAccessToken = (): string | undefined => {
  try {
    return JSON.parse(localStorage.getItem("userDetails") || "{}")?.accessToken;
  } catch {
    return undefined;
  }
};

export const apiClient = axios.create({
  baseURL: API_V1_URL,
  timeout: ENV.requestTimeoutMs,
  headers: { Accept: "application/json" },
});

apiClient.interceptors.request.use((config) => {
  if (isSessionExpired()) {
    endSession();
    return Promise.reject(new Error("Your session has expired. Please sign in again."));
  }
  const token = readAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) endSession();
    return Promise.reject(error);
  }
);

export const apiFetch = (pathOrUrl: string, init: RequestInit = {}) => {
  const url = /^https?:\/\//i.test(pathOrUrl)
    ? pathOrUrl
    : `${API_V1_URL}/${pathOrUrl.replace(/^\/+/, "")}`;
  if (window.location.pathname.startsWith("/admin") && isSessionExpired()) {
    endSession();
    return Promise.reject(new Error("Your session has expired. Please sign in again."));
  }
  const token = readAccessToken();
  const headers = new Headers(init.headers);
  headers.set("Accept", "application/json");
  if (token && !headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);
  return fetch(url, { ...init, headers }).then((response) => {
    const isLoginRequest = url.includes("/auth/v1/login");
    if (!isLoginRequest && (response.status === 401 || response.status === 403)) endSession();
    return response;
  });
};
